import * as React from 'react'
import { Item } from '@react-stately/collections'
import { Permission } from 'types'
import { Select } from 'components/Select/Select'
import { PermissionSelectProps } from './Types'

const PermissionSelect = ({
  isDisabled,
  onSelectionChange,
  selectedKey,
  size = 'md',
  disabledKeys,
  revokable = false,
  capitalize = true,
  placeholder = 'No Access',
  ...otherProps
}: PermissionSelectProps) => {
  const handleChange = (newValue: React.ReactText) => {
    onSelectionChange(newValue as Permission)
  }

  const PERMISSIONS_LABELS = {
    edit: capitalize ? 'Edit' : 'edit',
    comment: capitalize ? 'Comment' : 'comment',
    read: capitalize ? 'Read only' : 'read',
  }

  const permissionsList = [
    <Item key={Permission.Edit}>{PERMISSIONS_LABELS[Permission.Edit]}</Item>,
    <Item key={Permission.Comment}>{PERMISSIONS_LABELS[Permission.Comment]}</Item>,
    <Item key={Permission.Read}>{PERMISSIONS_LABELS[Permission.Read]}</Item>,
  ]

  if (revokable && selectedKey) {
    permissionsList.push(<Item key="">Revoke</Item>)
  }

  return (
    <Select
      aria-label="Permission"
      placeholder={placeholder}
      isDisabled={isDisabled}
      size={size}
      onSelectionChange={handleChange}
      selectedKey={selectedKey}
      disabledKeys={disabledKeys}
      {...otherProps}
    >
      {permissionsList}
    </Select>
  )
}

export { PermissionSelect }
